import React from 'react';
import { images } from '../../../Constants/ImageUrls';
import { NoCostEmiContainer } from './styled';

function NoCostEmi(props) {
  const { price } = props;
  return (
    <NoCostEmiContainer>
      <p>EMI Starts at ₹{Math.ceil(price / 3)}/month at 0% Interest</p>
      <div>
        Secured by <img src={images.razorpay} alt="razorpay" />
      </div>
    </NoCostEmiContainer>
  );
}

export default NoCostEmi;
